import { Modal } from 'antd'

import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { SubmitType } from '@eastcoal/formily/components/CrudForm/enums/SubmitType'
import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'
import { useCrudModalFormStore } from '@eastcoal/formily/components/CrudModalForm/Store/hooks/useStore'

import { AuctionFeeConfirmModalButtonProps } from './interface'
import { useFeeConfirm } from './useFeeConfirm'

/**
 * 竞价场次编辑弹窗保存按钮（带服务费/入场费二次确认，提交成功后关闭弹窗）
 */
export const AuctionFeeConfirmModalSaveButton = ({
  icon,
  type = 'primary',
  children = '保存',
  ...restProps
}: AuctionFeeConfirmModalButtonProps) => {
  const { mode, submitLoading } = useCrudFormStore(state =>
    pick(state, ['mode', 'submitLoading'])
  )
  const { toggleModalOpen } = useCrudModalFormStore(state =>
    pick(state, ['toggleModalOpen'])
  )

  const {
    isModalOpen,
    confirmContent,
    handleClick,
    handleConfirm,
    handleCancel
  } = useFeeConfirm({
    // 与 CrudModalForm 原 SaveButton 保持一致：提交成功后关闭弹窗
    onSubmitted: toggleModalOpen
  })

  if (mode === FormMode.READ) {
    return null
  }

  return (
    <>
      <ActionButton
        ghost
        htmlType='submit'
        icon={icon}
        loading={submitLoading}
        type={type}
        onClick={() => handleClick({ submitType: SubmitType.SAVE })}
        {...restProps}
      >
        {children}
      </ActionButton>
      <Modal
        cancelText='否'
        okText='是'
        open={isModalOpen}
        title='提示'
        onCancel={handleCancel}
        onOk={handleConfirm}
      >
        {confirmContent}
      </Modal>
    </>
  )
}
